export default __webpack_public_path__ + "static/glass-11-b5def99dff27aef155b40df4da19aaf3.jpg";